import { useQuery } from '@tanstack/react-query'

import { getFreeeAccountItems } from '@src/api'
import { DefaultApiGetFreeeAccountItemsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchFreeeAccountItems = (
  params: DefaultApiGetFreeeAccountItemsRequest
) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: !!params.organizationId && !!params.companyId,
    queryFn: () => getFreeeAccountItems(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_FREEE_ACCOUNT_ITEMS],
  })
}
